import { Component, Input, OnInit } from '@angular/core';
import { Moment, sosMoment } from '../../services/moment.service';

@Component({
    selector: 'ah-created-updated',
    templateUrl: './created-updated.component.html',
    styles: [`
        div {
            font-size: 12px;
            color: gray
        }

        .ago {
            color: #5ea6bd;
        }
    `],
    standalone: false
})
export class CreatedUpdatedComponent implements OnInit {
    @Input() entity: CreatedUpdatedEntity;
    moment;

    constructor() {
        this.moment = sosMoment;
    }

    ngOnInit() {
    }
}

export interface CreatedUpdatedEntity {
    created_at: Moment | Date;
    updated_at: Moment | Date;
}
